import { SingleWorkspaceDatasourceInformation } from './SingleWorkspaceDatasourceInformation';
import { SingleComponentTypeDatasourceInformation } from './SingleComponentTypeDatasourceInformation';
import { MultipleWorkspacesDatasourceInformation } from './MultipleWorkspacesDatasourceInformation';
import { MultipleComponentTypesDatasourceInformation } from './MultipleComponentTypesDatasourceInformation';
import type { DatasourceInformationData } from './getDataSourceInformationData';

export type DatasourceInformationProps = {
  data: DatasourceInformationData;
};

export const DatasourceInformation = ({ data }: DatasourceInformationProps) => {
  if (!data) {
    return null;
  }

  switch (data.dataSourceType) {
    case 'single-workspace':
      return <SingleWorkspaceDatasourceInformation {...data.props} />;

    case 'single-component-type':
      return <SingleComponentTypeDatasourceInformation {...data.props} />;

    case 'multiple-workspaces':
      return <MultipleWorkspacesDatasourceInformation {...data.props} />;

    case 'multiple-component-types':
      return <MultipleComponentTypesDatasourceInformation {...data.props} />;

    default:
      data satisfies never;
      return null;
  }
};
